import React from "react";
import SelectedProvisionally from "src/components/feature/SelectedProvisionally";

const Selected = () => {
  return <SelectedProvisionally />;
};

export default Selected;